import { render, staticRenderFns } from "./ChannelDetail.view.vue?vue&type=template&id=ca655e8e&"
import script from "./ChannelDetail.view.vue?vue&type=script&lang=js&"
export * from "./ChannelDetail.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports